import styled from 'styled-components';
import {Button} from '../../styles/components/button.style';
import {media} from '../../styles/components/media-queries';

export const Wrapper = styled.div`
  background-color: ${props => props.theme.defaultModal.backgroundColor};
  overflow-y: auto;
  width: ${props => props.theme.defaultModal.width.desktop};
  position: relative;
  padding: ${props => props.theme.defaultModal.padding};
  color: ${props => props.theme.defaultModal.color};
  text-align: center;
  justify-content: center;
  font-family: ${props => props.theme.primaryFontFamily};
  ${media.medium`
    width: ${props => props.theme.defaultModal.width.tablet};
  `};
  ${media.small`
    width: ${props => props.theme.defaultModal.width.phone};
    height: 100%;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  `};
  &::after {
    font-family: 'icomoon';
    font-size: 3rem;
    content: '\\f00d';
    color: ${props => props.theme.defaultModal.color};
    position: absolute;
    top: 1rem;
    right: 1rem;
  }
`;

export const StatusImage = styled.img`
  width: 20rem;
  height: 20rem;
`;

export const Status = styled.div`
  width: 100%;
  height: 24rem;
  display: block;
  text-align: center;
  font-size: 1.4rem;
`;

export const Header = styled.div`
  background-color: ${props => props.theme.primaryColor};
  border-bottom-width: 0.1rem;
  border-bottom-style: solid;
  border-bottom-color: ${props => props.theme.basketModal.borderColor};
`;

export const Title = styled.span`
  display: block;
  text-align: left;
  text-rendering: optimizelegibility;
  font-weight: bold;
  font-size: ${props => props.theme.basketItem.text.fontSize};
  color: ${props => props.theme.secondaryColor};
  padding: ${props => props.theme.padding};
`;

export const Name = styled(Title)`
  text-align: center;
  font-weight: normal;
  font-size: 1.8rem;
`;

export const Text = styled.span`
  display: block;
  font-size: ${props => props.theme.basketItem.text.fontSize};
  padding-left: ${props => props.theme.padding};
  padding-right: ${props => props.theme.padding};
`;

export const Paragraph = styled.p`
  font-size: 1.4rem;
  line-height: ${props => props.theme.lineHeight};
  margin-bottom: ${props => props.theme.margin};
  text-align: ${props => props.left ? 'left' : 'center'};
  a {
    text-decoration: none;
    color: ${props => props.theme.checkoutPage.linkColor};
  }
`;

export const Ok = Button.extend`
  float: right;
`;

export const CloseButton = styled.div`
  position: absolute;
  top: ${props => props.theme.margin};
  right: ${props => props.theme.margin};
  cursor: pointer;
  width: 2rem;
  height: 2rem;
  padding: 0.4rem;
  z-index: 1;
  ${media.small`
    display: none;
  `};
`;

export const MealPhoto = styled.img`
  max-width: 100%;
  max-height: 100%;
`;



// WEBPACK FOOTER //
// ./components/Modal/modal.style.js